export const defaultUpcomingText =
    '<h2>Coming Soon!</h2><p>We’re looking forward to receiving your feedback. Please come back when the public comment period opens.</p>';

export const defaultOpenText =
    '<h2>Let us know what you think!</h2><p>We would like to hear from you about this project and how it could affect you, your community and the environment.</p>';

export const defaultClosedText = '<h2>We heard you</h2><p>This public comment period closed.</p>';

export const submissionStatusArray = [defaultUpcomingText, defaultOpenText, defaultClosedText];
